import { ICalloutContentStyles } from '@fluentui/react';
import { IPText } from 'baseComponents';
import { IPCallout } from 'baseComponents/Callout/IPCallout';
import { IPStack } from 'baseComponents/Stack/IPStack';
import TagCreator from 'components/Tags/TagCreator';
import { globalStackTokensGapMedium, globalTextStylesBold } from 'globalStyles';
import Tag from 'models/tag';
import { useTranslation } from 'react-i18next';

interface ICreateTagCallOut {
  targetId: string;
  tagCache: Tag[];
  onClose: () => void;
  onCreate: (tag: Tag) => void;
  isVisible: boolean;
  defaultGroup?: string | undefined;
}

const CreateTagCallOut = (props: ICreateTagCallOut) => {
  const { t } = useTranslation(['translation', 'tags']);

  const calloutStyle: Partial<ICalloutContentStyles> = {
    root: {
      padding: '10px 12px',
      maxWidth: 600,
    },
  };

  return (
    <IPCallout
      hidden={!props.isVisible}
      styles={calloutStyle}
      setInitialFocus
      gapSpace={0}
      target={`#${props.targetId}`}
      onDismiss={() => {
        props.onClose();
      }}
    >
      <IPStack tokens={globalStackTokensGapMedium}>
        <IPStack.Item>
          <IPText variant="mediumPlus" styles={globalTextStylesBold}>
            {t('tag:Creator.Label')}
          </IPText>
        </IPStack.Item>
        <TagCreator
          tagCache={props.tagCache}
          onClose={props.onClose}
          onCreate={props.onCreate}
          saveButtonText={t('translation:General.Button.Add')}
          defaultGroup={props.defaultGroup}
        />
      </IPStack>
    </IPCallout>
  );
};

export default CreateTagCallOut;
